import React, { useEffect } from 'react'
import './Latest_Audio.css'
import Common_Back_Header from '../../common/common_components/common_back_header/Common_Back_Header'
import Latest_Card from '../../common/common_components/latest_card/Latest_Card'
import { useDispatch, useSelector } from 'react-redux'
import { AllChants } from '../../../features/admin/common/Slice'
import Pravachan_Card from '../gurujis_pravachan/pravachan_card/Pravachan_Card'

const All_latest_audio = () => {

    const dispatch = useDispatch();
    const chantsAl = useSelector((state) => state.common.all_chants);


    useEffect(() => {
        dispatch(AllChants());
    }, [dispatch]);
    return (
        <>
            <section className='Latest_Audio'>
                <div className="container">
                    <Common_Back_Header backNavigation={-1} />

                    <div className="row">
                        {chantsAl?.map((chant, index) => {
                            return (
                                <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                                    <Pravachan_Card
                                        image={chant?.image}
                                        name={chant?.name}
                                        album={chant?.Chant_Type?.name}
                                        music={chant}
                                    />
                                </div>
                            );
                        })}
                        {/* {Array?.from({ length: 8 })?.map(
                            ((_, index) => (
                                <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>
                                    <Latest_Card
                                        mediaContent={
                                            <img src='/assets/images/insight/latest_audio/img3.jpg' className='media_content' />
                                        }
                                    />
                                </div>
                            ))
                        )} */}
                    </div>
                </div>
            </section>
        </>
    )
}

export default All_latest_audio